// Role-name aliases (Feb 2026): the customer's team uses "Interior Consultant Manager"
// and "Interior Consultant" as their functional equivalent of Sales Manager /
// Sales Executive. UI role checks should treat these interchangeably.
export const SM_ROLE_NAMES = ["Sales Manager", "Interior Consultant Manager"];
export const SE_ROLE_NAMES = ["Sales Executive", "Interior Consultant"];
export const SALES_ROLE_NAMES = [...SM_ROLE_NAMES, ...SE_ROLE_NAMES];

export const isSalesManagerRole = (name) => SM_ROLE_NAMES.includes(name);
export const isSalesExecutiveRole = (name) => SE_ROLE_NAMES.includes(name);
export const isSalesRole = (name) => SALES_ROLE_NAMES.includes(name);
